import React from 'react';

const Community = () => {
  return (
    <main className="min-h-screen pt-20">
      <section className="bg-cream py-20 md:py-32">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <h1 className="font-playfair text-4xl md:text-5xl lg:text-6xl font-bold text-center text-espresso mb-8">
            Our Community
          </h1>
          <div className="h-1 w-24 bg-burnt-amber mx-auto mb-12"></div>
          <p className="font-nunito text-center text-espresso/80 text-lg max-w-3xl mx-auto">
          We see our spaces as more than just cafés—they’re gathering spots built around good food and shared experiences. Brunch Club Hospitality is rooted in fostering a sense of belonging, whether it’s through everyday moments over thoughtfully crafted dishes or initiatives across our projects that bring people together. We’re committed to creating warm, inclusive environments that feel both welcoming and connected.
          </p>
          
          <div className="mt-20 text-center">
            <p className="font-nunito text-espresso/60">Content coming soon...</p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Community;

